import { render } from "./DatasetItem.vue?vue&type=template&id=3de6ae3e"
import script from "./DatasetItem.vue?vue&type=script&lang=js"
export * from "./DatasetItem.vue?vue&type=script&lang=js"
script.render = render

export default script